var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "1200px",
      "transition": "dialog-bottom-transition",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-open-in-new")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportRepairEstimateRequestDialog.title", {
    title: _vm.report.title
  })) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click() {
        return _vm.close();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-window', {
    model: {
      value: _vm.step,
      callback: function callback($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": _vm.RepairEstimateRequestSteps.FORM
    }
  }, [_c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportRepairEstimateRequestDialog.text")) + " ")]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "date",
      "label": _vm.$t('components.PartnerReportDetail.repair.ReportRepairEstimateRequestDialog.dateLabel'),
      "persistent-hint": "",
      "outlined": "",
      "hint": _vm.$t('components.PartnerReportDetail.repair.ReportRepairEstimateRequestDialog.dateHint')
    },
    model: {
      value: _vm.costEstimateRequest.dateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.costEstimateRequest, "dateFormable", $$v);
      },
      expression: "costEstimateRequest.dateFormable"
    }
  })], 1)], 1)], 1), _c('v-divider', {
    staticClass: "d-none d-md-block",
    attrs: {
      "vertical": ""
    }
  }), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportRepairEstimateRequestDialog.seller")) + " ")]), _c('v-radio-group', {
    model: {
      value: _vm.requestAt,
      callback: function callback($$v) {
        _vm.requestAt = $$v;
      },
      expression: "requestAt"
    }
  }, [_vm.report.workshopCompanyId ? _c('company-sheet', {
    attrs: {
      "company": _vm.report.workShopCompany,
      "radioValue": _vm.workshopEnum
    }
  }) : _vm._e(), _vm.report.damageBrokerCompanyId ? _c('company-sheet', {
    staticClass: "mt-2",
    attrs: {
      "company": _vm.report.damageBrokerCompany,
      "radioValue": _vm.damageBrokerEnum
    }
  }) : _vm._e(), !_vm.report.damageBrokerCompanyId && !_vm.report.workshopCompanyId ? _c('m-no-content', {
    attrs: {
      "text": _vm.$t('components.PartnerReportDetail.repair.ReportRepairEstimateRequestDialog.noSeller')
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "mt-6 pa-4"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "outlined": "",
      "loading": _vm.requestsLoading,
      "disabled": !_vm.validForm
    },
    on: {
      "click": function click() {
        return _vm.createAndClose();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportRepairEstimateRequestDialog.create")) + " ")]), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "color": "primary",
      "loading": _vm.requestsLoading,
      "disabled": !_vm.validForm
    },
    on: {
      "click": function click() {
        return _vm.createReportAndSend();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportRepairEstimateRequestDialog.createAndSend")) + " ")])], 1)], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.RepairEstimateRequestSteps.SEND_MAIL
    }
  }, [_c('v-card-text', [_vm.RepairEstimateRequestSteps.SEND_MAIL === _vm.step ? _c('preselect-template-card', {
    ref: "templateCard",
    staticClass: "mt-1",
    attrs: {
      "templateKey": _vm.PreselectTemplateKeysEnum.REQUEST_REPAIR_ESTIMATE_MAIL,
      "language": _vm.partner.language,
      "partnerId": _vm.costEstimateRequest.partnerId,
      "from": [_vm.partner],
      "context": _vm.context,
      "to": _vm.costEstimateRequest.seller ? [_vm.costEstimateRequest.seller.email] : [],
      "refs": [{
        refId: _vm.costEstimateRequest.id,
        refType: _vm.ResourceEnum.REPAIR_ESTIMATE
      }, {
        refId: _vm.report.id,
        refType: _vm.ResourceEnum.REPORT
      }],
      "isTicketEnabled": true,
      "attachmentFileFilters": _vm.attachmentFileFilters
    }
  }) : _vm._e()], 1), _c('v-card-actions', {
    staticClass: "mt-6 pa-4"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "color": "primary",
      "loading": _vm.requestsLoading
    },
    on: {
      "click": function click() {
        return _vm.sendMail();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("submit")) + " ")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }